import { latLng, LatLng } from "leaflet";

export default class GeoUtils {
  private static π: number = Math.PI;
  private static R: number = 3443.92; //Earth radius, nm

  private static toRadians(grados: number): number {
    return (grados * this.π) / 180;
  }

  private static toDegrees(radians: number): number {
    return (radians * 180) / this.π;
  }

  private static coordsToDegrees(coords: LatLng): LatLng {
    const lat = this.toDegrees(coords.lat);
    const lng = ((this.toDegrees(coords.lng) + 540) % 360) - 180;
    return latLng(lat, lng);
  }

  private static coordsToRadians(coords: LatLng): LatLng {
    const φ = this.toRadians(coords.lat); //latitude
    const λ = this.toRadians(coords.lng); //longitude
    return latLng(φ, λ)
  }

  private static distanceCalculatorFromPoint(startPoint: LatLng, d: number, brng: number): LatLng {
    const φ1 = startPoint.lat
    const λ1 = startPoint.lng
    const φ2 = Math.asin(
      Math.sin(φ1) * Math.cos(d / this.R) +
      Math.cos(φ1) * Math.sin(d / this.R) * Math.cos(brng)
    );
    const λ2 = λ1 +
      Math.atan2(
        Math.sin(brng) * Math.sin(d / this.R) * Math.cos(φ1),
        Math.cos(d / this.R) - Math.sin(φ1) * Math.sin(φ2));
    return latLng(φ2, λ2)
  }


  public static midpointCalculator(
    coords2: LatLng,
    coords1: LatLng
  ): LatLng {
    //Punto inicial
    const φ1 = this.toRadians(coords1.lat); //latitude
    const λ1 = this.toRadians(coords1.lng); //longitude

    //Punto final
    const φ2 = this.toRadians(coords2.lat); //latitude
    const λ2 = this.toRadians(coords2.lng); //longitude

    const Bx = Math.cos(φ2) * Math.cos(λ2 - λ1);
    const By = Math.cos(φ2) * Math.sin(λ2 - λ1);
    const φ3 = Math.atan2(
      Math.sin(φ1) + Math.sin(φ2),
      Math.sqrt((Math.cos(φ1) + Bx) * (Math.cos(φ1) + Bx) + By * By)
    );
    const λ3 = λ1 + Math.atan2(By, Math.cos(φ1) + Bx);

    return this.coordsToDegrees(latLng(φ3, λ3))
  }

  public static turnCalculator(
    coords: LatLng,
    cog: number,
    d: number = 0.03
  ): LatLng {
    const startPoint = this.coordsToRadians(coords)
    const brng = this.toRadians(cog); //Intial COG
    const endPoint: LatLng = this.distanceCalculatorFromPoint(startPoint, d, brng)
    return this.coordsToDegrees(endPoint)
  }

  public static endPointCalculator(
    coords: LatLng,
    sog: number,
    cog: number,
    time: number
  ): LatLng {
    const d = sog * (time / 60); //distance in nautical miles
    const startPoint = this.coordsToRadians(coords)
    const brng = this.toRadians(cog); //Intial COG
    const endPoint: LatLng = this.distanceCalculatorFromPoint(startPoint, d, brng)
    return this.coordsToDegrees(endPoint)
  }

  public static headingLineCalculator(
    coords: LatLng,
    cog: number,
    d: number = 0.25
  ): LatLng {
    const startPoint = this.coordsToRadians(coords)
    const brng = this.toRadians(cog); //Intial COG
    const endPoint: LatLng = this.distanceCalculatorFromPoint(startPoint, d, brng)
    return this.coordsToDegrees(endPoint)
  }
}
